export const curriData = [
    {
        id : 1 ,
        secTitle : "섹션 0. 강의소개" ,
        total: "3강 6분" , 
        unit : [
            {
                unitId : 1, 
                unitName : "강의소개" ,
                preview : true 
            } ,
            {
                unitId : 2, 
                unitName : "학습방법" ,
                preview : true 
            }
        ]
    } , 
    {
        id : 2 ,
        secTitle : "섹션 1. 환경설정" ,
        total: "3강 5분" , 
        unit : [
            {
                unitId : 1, 
                unitName : "파이썬 소개 및 설치" ,
                preview : true 
            } ,
            {
                unitId : 2, 
                unitName : "VS CODE 설치 및 설명" ,
                preview : false
            }
        ]
    }
]